import { render, staticRenderFns } from "./TietoNavBar.vue?vue&type=template&id=1d4354ef&scoped=true&"
import script from "./TietoNavBar.vue?vue&type=script&lang=js&"
export * from "./TietoNavBar.vue?vue&type=script&lang=js&"
import style0 from "./TietoNavBar.vue?vue&type=style&index=0&id=1d4354ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4354ef",
  null
  
)

export default component.exports